import { z } from 'zod/v4';
import { createDefinitionSchema } from '../utils/helpers';

export type MockProgressiveDataQueryLoadingType = z.infer<typeof mockProgressiveDataQueryDataLoadingSchema>;
const mockProgressiveDataQueryDataLoadingSchema = z.enum(['Progressive', 'Basic']);
export const DEFAULT_MOCK_PROGRESSIVE_DATA_QUERY_LOADING_TYPE: MockProgressiveDataQueryLoadingType = 'Progressive';

export type MockProgressiveDataQueryProgressiveResponse = z.infer<
  typeof mockProgressiveDataQueryDataProgressiveResponseSchema
>;
const mockProgressiveDataQueryDataProgressiveResponseSchema = z.enum(['All', 'Partial']);
export const DEFAULT_MOCK_PROGRESSIVE_DATA_QUERY_PROGRESSIVE_RESPONSE: MockProgressiveDataQueryProgressiveResponse =
  'All';

const mockProgressiveDataQueryTriggerErrorSchema = z.enum(['Never', 'OnFirstResult', 'OnUpdate']);
export type MockProgressiveDataQueryTriggerError = z.infer<typeof mockProgressiveDataQueryTriggerErrorSchema>;

export type MockProgressiveDataQuerySpec = z.infer<typeof MockProgressiveDataQuerySpecSchema>;
const MockProgressiveDataQuerySpecSchema = z.object({
  query: z.string(),
  loading_type: mockProgressiveDataQueryDataLoadingSchema.default(DEFAULT_MOCK_PROGRESSIVE_DATA_QUERY_LOADING_TYPE),
  progressive_response: mockProgressiveDataQueryDataProgressiveResponseSchema
    .default(DEFAULT_MOCK_PROGRESSIVE_DATA_QUERY_PROGRESSIVE_RESPONSE)
    .optional(),
  trigger_error: mockProgressiveDataQueryTriggerErrorSchema.optional(),
});

export type MockProgressiveDataQueryDefinition = z.infer<typeof MockProgressiveDataQueryDefinitionSchema>;
export const MockProgressiveDataQueryDefinitionSchema = createDefinitionSchema(
  'MockProgressiveDataQuery',
  MockProgressiveDataQuerySpecSchema
);
